module.exports = __webpack_public_path__ + "img/deleted.895210c4.png";